
import { Helmet } from 'react-helmet-async';

interface LocalBusinessSchemaProps {
  businessName: string;
  city?: string;
  state?: string;
  stateAbbreviation?: string;
  serviceType: string;
  areaServed?: string;
  description?: string;
  url?: string;
}

export const LocalBusinessSchema = ({ 
  businessName, 
  city, 
  state, 
  stateAbbreviation, 
  serviceType, 
  areaServed,
  description,
  url 
}: LocalBusinessSchemaProps) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": businessName,
    "description": description || `Professional Employer Organization services in ${city || state}`,
    "url": url || "https://thepeoapp.com",
    "serviceType": serviceType,
    "areaServed": {
      "@type": city ? "City" : "State",
      "name": areaServed || city || state,
      ...(city && state && {
        "containedInPlace": {
          "@type": "State",
          "name": state
        }
      })
    },
    "address": {
      "@type": "PostalAddress",
      ...(city && { "addressLocality": city }),
      ...(stateAbbreviation && { "addressRegion": stateAbbreviation }),
      "addressCountry": "US"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Service",
      "url": "https://thepeoapp.com/application"
    },
    "openingHours": "Mo-Fr 09:00-17:00",
    "priceRange": "$$"
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};
